import React from 'react';

const LasikEyesLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="lasikEyesLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g transform="matrix(-0.470351,0,0,0.376281,77.632,9.04885)">
        <path
          d="M-0.001,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 -0.001,0C3.121,0 5.651,-2.531 5.651,-5.653C5.651,-8.774 3.121,-11.305 -0.001,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,74.0879,16.8473)">
        <path
          d="M0.001,-7.537C-2.08,-7.537 -3.768,-5.85 -3.768,-3.769C-3.768,-1.687 -2.08,0 0.001,0C2.082,0 3.769,-1.687 3.769,-3.769C3.769,-5.85 2.082,-7.537 0.001,-7.537"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,82.0632,20.392)">
        <path
          d="M0,-7.537C-2.081,-7.537 -3.769,-5.85 -3.769,-3.768C-3.769,-1.687 -2.081,0 0,0C2.081,0 3.769,-1.687 3.769,-3.768C3.769,-5.85 2.081,-7.537 0,-7.537"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,104.218,25.3544)">
        <path
          d="M0,-7.536C-2.081,-7.536 -3.769,-5.849 -3.769,-3.768C-3.769,-1.687 -2.081,0 0,0C2.081,0 3.769,-1.687 3.769,-3.768C3.769,-5.849 2.081,-7.536 0,-7.536"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,20.0302,16.1381)">
        <path
          d="M0,-7.536C-2.081,-7.536 -3.768,-5.849 -3.768,-3.768C-3.768,-1.687 -2.081,0 0,0C2.081,0 3.768,-1.687 3.768,-3.768C3.768,-5.849 2.081,-7.536 0,-7.536"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,78.5186,14.0114)">
        <path
          d="M0,-11.305C-3.121,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.121,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,98.9008,18.9742)">
        <path
          d="M0,-7.537C-2.081,-7.537 -3.769,-5.85 -3.769,-3.769C-3.769,-1.688 -2.081,0 0,0C2.081,0 3.769,-1.688 3.769,-3.769C3.769,-5.85 2.081,-7.537 0,-7.537"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,85.6082,18.9742)">
        <path
          d="M0.001,-7.537C-2.08,-7.537 -3.768,-5.85 -3.768,-3.769C-3.768,-1.688 -2.08,0 0.001,0C2.082,0 3.769,-1.688 3.769,-3.769C3.769,-5.85 2.082,-7.537 0.001,-7.537"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,90.9255,42.3692)">
        <path
          d="M0.001,-7.536C-2.08,-7.536 -3.768,-5.849 -3.768,-3.768C-3.768,-1.687 -2.08,0 0.001,0C2.082,0 3.769,-1.687 3.769,-3.768C3.769,-5.849 2.082,-7.536 0.001,-7.536"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,109.534,28.1905)">
        <path
          d="M-0.001,-7.537C-2.082,-7.537 -3.769,-5.85 -3.769,-3.768C-3.769,-1.687 -2.082,0 -0.001,0C2.08,0 3.768,-1.687 3.768,-3.768C3.768,-5.85 2.08,-7.537 -0.001,-7.537"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,69.6563,14.0113)">
        <path
          d="M0,-18.841C-5.203,-18.841 -9.42,-14.623 -9.42,-9.421C-9.42,-4.218 -5.203,0 0,0C5.203,0 9.42,-4.218 9.42,-9.421C9.42,-14.623 5.203,-18.841 0,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,69.6568,47.332)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.537C-7.536,-3.375 -4.162,0 0.001,0C4.163,0 7.537,-3.375 7.537,-7.537C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,79.4048,37.4069)">
        <path
          d="M0.001,-18.841C-5.202,-18.841 -9.42,-14.623 -9.42,-9.421C-9.42,-4.218 -5.202,0 0.001,0C5.203,0 9.421,-4.218 9.421,-9.421C9.421,-14.623 5.203,-18.841 0.001,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,102.888,31.7349)">
        <path
          d="M0,-9.42C-2.602,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.602,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,98.4577,22.5186)">
        <path
          d="M0.001,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0.001,0C2.602,0 4.711,-2.108 4.711,-4.71C4.711,-7.311 2.602,-9.42 0.001,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,100.673,21.8097)">
        <path
          d="M-0.001,-7.536C-2.082,-7.536 -3.769,-5.849 -3.769,-3.768C-3.769,-1.687 -2.082,0 -0.001,0C2.08,0 3.768,-1.687 3.768,-3.768C3.768,-5.849 2.08,-7.536 -0.001,-7.536"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,81.6201,38.1154)">
        <path
          d="M0,-5.652C-1.562,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.562,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,78.0751,45.9138)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,55.9206,49.4587)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,65.6686,49.4587)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,82.5063,42.3692)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.386 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.562,0 2.826,-1.265 2.826,-2.826C2.826,-4.386 1.562,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,108.648,22.5189)">
        <path
          d="M-0.001,-3.769C-1.041,-3.769 -1.885,-2.925 -1.885,-1.885C-1.885,-0.844 -1.041,0 -0.001,0C1.04,0 1.884,-0.844 1.884,-1.885C1.884,-2.925 1.04,-3.769 -0.001,-3.769"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,98.9008,15.4291)">
        <path
          d="M0,-3.768C-1.041,-3.768 -1.884,-2.924 -1.884,-1.884C-1.884,-0.843 -1.041,0 0,0C1.04,0 1.884,-0.843 1.884,-1.884C1.884,-2.924 1.04,-3.768 0,-3.768"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,35.9816,48.0409)">
        <path
          d="M0,-3.768C-1.041,-3.768 -1.884,-2.924 -1.884,-1.884C-1.884,-0.843 -1.041,0 0,0C1.041,0 1.884,-0.843 1.884,-1.884C1.884,-2.924 1.041,-3.768 0,-3.768"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,9.83906,29.6081)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,11.1683,24.6458)">
        <path
          d="M0,-3.769C-1.041,-3.769 -1.884,-2.925 -1.884,-1.885C-1.884,-0.844 -1.041,0 0,0C1.041,0 1.884,-0.844 1.884,-1.885C1.884,-2.925 1.041,-3.769 0,-3.769"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,35.0953,43.7874)">
        <path
          d="M0,-3.769C-1.041,-3.769 -1.884,-2.925 -1.884,-1.885C-1.884,-0.844 -1.041,0 0,0C1.041,0 1.884,-0.844 1.884,-1.885C1.884,-2.925 1.041,-3.769 0,-3.769"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,30.2212,9.75761)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,33.7661,10.4664)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.386 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.386 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,39.5263,6.21282)">
        <path
          d="M0,-3.768C-1.041,-3.768 -1.884,-2.924 -1.884,-1.884C-1.884,-0.843 -1.041,0 0,0C1.041,0 1.884,-0.843 1.884,-1.884C1.884,-2.924 1.041,-3.768 0,-3.768"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,87.3805,11.1757)">
        <path
          d="M0,-7.537C-2.081,-7.537 -3.769,-5.85 -3.769,-3.769C-3.769,-1.687 -2.081,0 0,0C2.081,0 3.769,-1.687 3.769,-3.769C3.769,-5.85 2.081,-7.537 0,-7.537"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,75.8597,12.5936)">
        <path
          d="M0,-11.305C-3.121,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.121,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,21.3594,14.0112)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.386 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.386 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,17.8148,19.6827)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.386 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.386 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,104.661,30.3171)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.562,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.562,-5.652 0,-5.652"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,74.0879,35.989)">
        <path
          d="M0.001,-7.537C-2.08,-7.537 -3.768,-5.85 -3.768,-3.769C-3.768,-1.687 -2.08,0 0.001,0C2.082,0 3.769,-1.687 3.769,-3.769C3.769,-5.85 2.082,-7.537 0.001,-7.537"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,81.1771,31.7352)">
        <path
          d="M0,-11.305C-3.121,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.121,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,47.5018,40.2421)">
        <path
          d="M0,-11.304C-3.122,-11.304 -5.652,-8.774 -5.652,-5.652C-5.652,-2.53 -3.122,0 0,0C3.122,0 5.652,-2.53 5.652,-5.652C5.652,-8.774 3.122,-11.304 0,-11.304"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,39.5267,43.7874)">
        <path
          d="M0.001,-15.073C-4.161,-15.073 -7.536,-11.699 -7.536,-7.537C-7.536,-3.375 -4.161,0 0.001,0C4.163,0 7.537,-3.375 7.537,-7.537C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,31.5505,43.7874)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,35.9816,32.4442)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.775 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.775 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,38.6405,23.9367)">
        <path
          d="M0.001,-7.537C-2.081,-7.537 -3.768,-5.85 -3.768,-3.768C-3.768,-1.687 -2.081,0 0.001,0C2.082,0 3.769,-1.687 3.769,-3.768C3.769,-5.85 2.082,-7.537 0.001,-7.537"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,15.5993,28.8991)">
        <path
          d="M0,-11.304C-3.122,-11.304 -5.652,-8.774 -5.652,-5.652C-5.652,-2.53 -3.122,0 0,0C3.122,0 5.652,-2.53 5.652,-5.652C5.652,-8.774 3.122,-11.304 0,-11.304"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,22.6887,26.7726)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.775 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.775 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,46.6157,48.7498)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,53.7053,47.332)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,28.0059,14.7204)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,22.6892,35.2797)">
        <path
          d="M0.001,-15.073C-4.161,-15.073 -7.536,-11.699 -7.536,-7.536C-7.536,-3.374 -4.161,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.536C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,85.6078,39.5336)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.121,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.121,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,96.2419,35.2797)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.121,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.121,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,86.4939,32.4442)">
        <path
          d="M-0.001,-15.073C-4.163,-15.073 -7.537,-11.699 -7.537,-7.537C-7.537,-3.375 -4.163,0 -0.001,0C4.161,0 7.536,-3.375 7.536,-7.537C7.536,-11.699 4.161,-15.073 -0.001,-15.073"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,36.4246,10.4664)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,46.1726,5.50383)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.312 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.312 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,81.1766,26.7724)">
        <path
          d="M-0.001,-18.841C-5.203,-18.841 -9.421,-14.623 -9.421,-9.421C-9.421,-4.217 -5.203,0 -0.001,0C5.202,0 9.42,-4.217 9.42,-9.421C9.42,-14.623 5.202,-18.841 -0.001,-18.841"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,84.7216,34.5708)">
        <path
          d="M0,-7.536C-2.081,-7.536 -3.769,-5.849 -3.769,-3.768C-3.769,-1.687 -2.081,0 0,0C2.081,0 3.769,-1.687 3.769,-3.768C3.769,-5.849 2.081,-7.536 0,-7.536"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,87.3805,24.6457)">
        <path
          d="M0,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.537C-7.536,-3.375 -4.162,0 0,0C4.162,0 7.536,-3.375 7.536,-7.537C7.536,-11.699 4.162,-15.073 0,-15.073"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,78.5182,20.3919)">
        <path
          d="M-0.001,-18.841C-5.204,-18.841 -9.421,-14.624 -9.421,-9.421C-9.421,-4.218 -5.204,0 -0.001,0C5.202,0 9.42,-4.218 9.42,-9.421C9.42,-14.624 5.202,-18.841 -0.001,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,82.9493,17.5559)">
        <path
          d="M0,-11.304C-3.122,-11.304 -5.652,-8.774 -5.652,-5.652C-5.652,-2.53 -3.122,0 0,0C3.121,0 5.652,-2.53 5.652,-5.652C5.652,-8.774 3.121,-11.304 0,-11.304"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,92.6973,23.2275)">
        <path
          d="M0,-11.304C-3.121,-11.304 -5.652,-8.774 -5.652,-5.652C-5.652,-2.53 -3.121,0 0,0C3.122,0 5.652,-2.53 5.652,-5.652C5.652,-8.774 3.122,-11.304 0,-11.304"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,91.8112,28.1905)">
        <path
          d="M0,-11.305C-3.121,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.121,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,69.6568,9.04881)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.537C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.537C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,62.1241,11.1756)">
        <path
          d="M0,-13.189C-3.642,-13.189 -6.594,-10.236 -6.594,-6.595C-6.594,-2.953 -3.642,0 0,0C3.642,0 6.594,-2.953 6.594,-6.595C6.594,-10.236 3.642,-13.189 0,-13.189"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,96.6855,30.3171)">
        <path
          d="M0,-9.42C-2.602,-9.42 -4.71,-7.312 -4.71,-4.71C-4.71,-2.108 -2.602,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.312 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,94.0266,16.138)">
        <path
          d="M0,-9.42C-2.602,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.602,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,53.2622,2.668)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.386 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.386 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,58.5795,6.21267)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,90.4815,16.847)">
        <path
          d="M-0.001,-9.42C-2.602,-9.42 -4.711,-7.311 -4.711,-4.71C-4.711,-2.108 -2.602,0 -0.001,0C2.601,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.601,-9.42 -0.001,-9.42"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,67.8845,45.2053)">
        <path
          d="M0.001,-18.841C-5.202,-18.841 -9.42,-14.624 -9.42,-9.421C-9.42,-4.218 -5.202,0 0.001,0C5.204,0 9.421,-4.218 9.421,-9.421C9.421,-14.624 5.204,-18.841 0.001,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,72.3147,42.3692)">
        <path
          d="M-0.001,-18.841C-5.203,-18.841 -9.421,-14.623 -9.421,-9.421C-9.421,-4.217 -5.203,0 -0.001,0C5.202,0 9.42,-4.217 9.42,-9.421C9.42,-14.623 5.202,-18.841 -0.001,-18.841"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,77.632,42.3692)">
        <path
          d="M-0.001,-11.304C-3.122,-11.304 -5.652,-8.774 -5.652,-5.652C-5.652,-2.53 -3.122,0 -0.001,0C3.121,0 5.651,-2.53 5.651,-5.652C5.651,-8.774 3.121,-11.304 -0.001,-11.304"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,65.226,11.8845)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.698 -7.536,-7.536C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.536C7.537,-11.698 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,50.1602,11.8845)">
        <path
          d="M-0.001,-15.073C-4.163,-15.073 -7.537,-11.698 -7.537,-7.536C-7.537,-3.374 -4.163,0 -0.001,0C4.162,0 7.536,-3.374 7.536,-7.536C7.536,-11.698 4.162,-15.073 -0.001,-15.073"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,62.5676,4.79492)">
        <path
          d="M0.001,-7.536C-2.08,-7.536 -3.768,-5.849 -3.768,-3.768C-3.768,-1.687 -2.08,0 0.001,0C2.082,0 3.769,-1.687 3.769,-3.768C3.769,-5.849 2.082,-7.536 0.001,-7.536"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,57.2494,11.8845)">
        <path
          d="M-0.001,-18.841C-5.204,-18.841 -9.421,-14.623 -9.421,-9.421C-9.421,-4.217 -5.204,0 -0.001,0C5.202,0 9.42,-4.217 9.42,-9.421C9.42,-14.623 5.202,-18.841 -0.001,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,95.7993,38.1154)">
        <path
          d="M0.001,-5.652C-1.561,-5.652 -2.825,-4.387 -2.825,-2.826C-2.825,-1.265 -1.561,0 0.001,0C1.562,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.562,-5.652 0.001,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,58.5795,49.4587)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.312 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.312 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,26.2336,35.989)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,34.2091,37.4069)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,41.2986,33.8619)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,16.9285,23.2274)">
        <path
          d="M0,-9.42C-2.602,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.602,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,13.3837,29.6081)">
        <path
          d="M0,-5.652C-1.561,-5.652 -2.826,-4.387 -2.826,-2.826C-2.826,-1.265 -1.561,0 0,0C1.561,0 2.826,-1.265 2.826,-2.826C2.826,-4.387 1.561,-5.652 0,-5.652"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,43.0707,48.0405)">
        <path
          d="M-0.001,-7.536C-2.082,-7.536 -3.769,-5.849 -3.769,-3.768C-3.769,-1.687 -2.082,0 -0.001,0C2.081,0 3.768,-1.687 3.768,-3.768C3.768,-5.849 2.081,-7.536 -0.001,-7.536"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,40.4125,39.5336)">
        <path
          d="M0,-18.841C-5.203,-18.841 -9.42,-14.624 -9.42,-9.421C-9.42,-4.218 -5.203,0 0,0C5.203,0 9.42,-4.218 9.42,-9.421C9.42,-14.624 5.203,-18.841 0,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,49.2741,45.2053)">
        <path
          d="M0,-18.841C-5.203,-18.841 -9.42,-14.624 -9.42,-9.421C-9.42,-4.218 -5.203,0 0,0C5.203,0 9.42,-4.218 9.42,-9.421C9.42,-14.624 5.203,-18.841 0,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,34.6519,40.951)">
        <path
          d="M-0.001,-13.188C-3.643,-13.188 -6.595,-10.236 -6.595,-6.594C-6.595,-2.952 -3.643,0 -0.001,0C3.641,0 6.594,-2.952 6.594,-6.594C6.594,-10.236 3.641,-13.188 -0.001,-13.188"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,29.3352,39.5332)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,22.2457,39.5332)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,55.0345,43.0782)">
        <path
          d="M0,-9.42C-2.602,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.602,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,27.5629,28.899)">
        <path
          d="M0,-9.42C-2.601,-9.42 -4.71,-7.311 -4.71,-4.71C-4.71,-2.108 -2.601,0 0,0C2.602,0 4.71,-2.108 4.71,-4.71C4.71,-7.311 2.602,-9.42 0,-9.42"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,31.5505,26.7726)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.775 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.775 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,59.9087,45.2053)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.537C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.537C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,38.6405,21.8098)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.536C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.536C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,41.299,17.5561)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.698 -7.536,-7.536C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.536C7.537,-11.698 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,33.3226,21.8098)">
        <path
          d="M-0.001,-15.073C-4.163,-15.073 -7.537,-11.699 -7.537,-7.536C-7.537,-3.374 -4.163,0 -0.001,0C4.162,0 7.536,-3.374 7.536,-7.536C7.536,-11.699 4.162,-15.073 -0.001,-15.073"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,25.3473,18.9742)">
        <path
          d="M0,-7.537C-2.081,-7.537 -3.768,-5.85 -3.768,-3.769C-3.768,-1.688 -2.081,0 0,0C2.081,0 3.768,-1.688 3.768,-3.769C3.768,-5.85 2.081,-7.537 0,-7.537"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,28.8924,21.8098)">
        <path
          d="M0.001,-15.073C-4.162,-15.073 -7.536,-11.699 -7.536,-7.536C-7.536,-3.374 -4.162,0 0.001,0C4.163,0 7.537,-3.374 7.537,-7.536C7.537,-11.699 4.163,-15.073 0.001,-15.073"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,36.8677,14.0114)">
        <path
          d="M0,-11.305C-3.122,-11.305 -5.652,-8.774 -5.652,-5.653C-5.652,-2.531 -3.122,0 0,0C3.122,0 5.652,-2.531 5.652,-5.653C5.652,-8.774 3.122,-11.305 0,-11.305"
          style={{
            fill: 'rgb(62,191,185)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,43.9573,14.0113)">
        <path
          d="M0,-18.841C-5.203,-18.841 -9.42,-14.623 -9.42,-9.421C-9.42,-4.218 -5.203,0 0,0C5.203,0 9.42,-4.218 9.42,-9.421C9.42,-14.623 5.203,-18.841 0,-18.841"
          style={{
            fill: 'rgb(229,229,229)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,35.9812,31.0261)">
        <path
          d="M-0.001,-18.841C-5.204,-18.841 -9.421,-14.623 -9.421,-9.421C-9.421,-4.218 -5.204,0 -0.001,0C5.202,0 9.42,-4.218 9.42,-9.421C9.42,-14.623 5.202,-18.841 -0.001,-18.841"
          style={{
            fill: 'rgb(242,90,43)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,149.236,26.6306)">
        <path
          d="M0,14.131C-2.826,17.334 -6.405,18.652 -10.174,18.652C-14.695,18.652 -18.841,16.58 -18.841,12.247C-18.841,7.725 -14.319,5.841 -9.231,5.841C-5.841,5.841 -2.261,6.594 0.188,8.102L0.188,14.131L0,14.131ZM-9.231,-6.783C-12.812,-6.783 -16.58,-5.652 -19.595,-4.145L-18.841,-2.261C-16.392,-3.58 -13,-4.522 -9.797,-4.522C-5.087,-4.522 0,-2.073 0,2.826L0,5.841C-2.638,4.334 -6.406,3.58 -9.797,3.58C-16.015,3.58 -21.855,6.217 -21.855,12.247C-21.855,17.899 -16.58,20.914 -10.928,20.914C-6.782,20.914 -2.638,19.595 0.188,16.203L0.377,20.16L3.392,20.16L3.392,3.015C3.203,-3.391 -3.015,-6.783 -9.231,-6.783"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,157.566,30.0337)">
        <path
          d="M0,-3.58C-3.58,-4.334 -6.783,-5.087 -6.783,-8.29C-6.783,-11.682 -2.826,-13.377 1.695,-13.377C4.71,-13.377 7.913,-12.624 10.174,-11.305L11.116,-13.377C8.479,-14.885 5.087,-15.638 1.507,-15.638C-4.334,-15.638 -10.175,-13.377 -10.175,-8.29C-10.175,-3.392 -5.652,-2.261 -0.377,-1.319C4.333,-0.377 8.667,0 8.667,4.333C8.667,8.101 4.521,9.608 0.188,9.608C-4.146,9.608 -8.29,8.29 -10.551,6.406L-11.305,8.478C-8.667,10.739 -3.957,12.058 0.565,12.058C6.405,12.058 12.058,9.797 12.058,4.71C12.058,-1.884 6.217,-2.45 0,-3.58"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,128.411,34.2164)">
        <path
          d="M0,-36.551L-3.203,-36.551L-3.203,0L20.537,0L20.537,-2.26L0,-2.26L0,-36.551Z"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,-3.71936,1.40546)">
        <rect x="359.297" y="61.009" width="3.203" height="26.377" />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,180.164,29.608)">
        <path
          d="M0,-13.942L-3.768,-13.942L-18.275,-0.188L-18.275,-26.377L-21.479,-26.377L-21.479,12.435L-18.275,12.435L-18.275,3.768L-12.623,-1.318L-2.072,12.435L1.696,12.435L-10.928,-3.579L0,-13.942Z"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(-0.470351,0,0,0.376281,166.073,22.0936)">
        <path
          d="M0,-3.392C1.13,-3.392 1.884,-2.639 1.884,-1.696C1.884,-0.754 1.13,0 0,0C-1.131,0 -1.884,-0.754 -1.884,-1.696C-1.884,-2.639 -0.942,-3.392 0,-3.392"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,191.064,20.4627)">
        <path
          d="M0,36.74L24.682,36.74L24.682,34.102L3.579,34.102L3.579,19.03L22.985,19.03L22.985,16.392L3.579,16.392L3.579,2.638L24.682,2.638L24.682,0L0,0L0,36.74Z"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,210.028,30.2465)">
        <path
          d="M0,7.724L-9.985,-15.639L-13.188,-15.639L-1.695,10.739L-0.942,10.739L-2.826,14.884C-3.58,16.956 -4.898,18.652 -6.782,19.594C-8.667,20.725 -10.928,21.289 -13.754,21.289L-13.754,23.551C-10.739,23.551 -7.913,22.985 -5.652,21.666C-3.58,20.348 -1.695,18.463 -0.377,15.637L13.377,-15.827L10.174,-15.827L0,7.724Z"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,228.284,29.3245)">
        <path
          d="M0,-0.188L-21.29,-0.188L-21.29,-0.753C-21.102,-6.971 -17.334,-11.493 -10.174,-11.493C-3.58,-11.493 0.188,-8.855 0.188,-2.449C0.188,-1.884 0.188,-1.13 0,-0.188M-10.174,-13.942C-19.406,-13.942 -24.305,-7.913 -24.305,-0.188C-24.305,7.914 -19.029,13.754 -9.797,13.754C-5.841,13.754 -2.072,12.812 0.942,10.928L-0.565,9.232C-3.392,10.551 -6.595,11.305 -9.797,11.305C-16.392,11.305 -20.537,7.348 -21.102,1.508L3.015,1.508C3.203,0.188 3.392,-0.942 3.392,-1.884C3.015,-9.608 -1.695,-13.942 -10.174,-13.942"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,235.816,30.0337)">
        <path
          d="M0,-3.58C-3.579,-4.334 -6.782,-5.087 -6.782,-8.29C-6.782,-11.682 -2.826,-13.377 1.696,-13.377C4.71,-13.377 7.913,-12.624 10.174,-11.305L11.116,-13.377C8.479,-14.885 5.087,-15.638 1.508,-15.638C-4.333,-15.638 -10.174,-13.377 -10.174,-8.29C-10.174,-3.392 -5.652,-2.261 -0.377,-1.319C4.334,-0.377 8.667,0 8.667,4.333C8.667,8.101 4.521,9.608 0.188,9.608C-4.145,9.608 -8.29,8.29 -10.551,6.406L-11.305,8.478C-8.667,10.739 -3.956,12.058 0.565,12.058C6.406,12.058 12.059,9.797 12.059,4.71C12.247,-1.884 6.406,-2.45 0,-3.58"
          style={{ fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.470351,0,0,0.376281,-3.71936,0.129871)">
        <rect x="392.269" y="74.762" width="13.377" height="2.261" />
      </g>
    </g>
  </svg>
);

export default LasikEyesLogo;
